import { RootState } from './../../app/store';

export const selectTournaments = (state: RootState) => state.tournaments;
export const isTournamentsLoading = (state: RootState) => state.tournaments.isLoading;